document.addEventListener("DOMContentLoaded", () => {
  const slideshows = document.querySelectorAll("slideshow-component");

  slideshows.forEach(slideshow => {
    // Dawn-style slideshow stores logic inside slideshow.slider
    if (!slideshow.slider) return;

    // Disable pause on hover by killing hover events
    if (slideshow.slider.onMouseEnter) slideshow.slider.onMouseEnter = () => {};
    if (slideshow.slider.onMouseLeave) slideshow.slider.onMouseLeave = () => {};

    // Some themes use this option
    slideshow.slider.pauseOnHover = false;
  });
});
